const transitions = {
	button: '0.2s ease',
	default: '0.3s ease',
};

export default transitions;
